import React, { forwardRef } from 'react';
import { Slide, SlideProps } from '@mui/material';

const Transition = forwardRef<unknown, SlideProps>(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default Transition;
